import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { addClass } from '@fretadao/f-js-dom';
import { isBlank } from '@fretadao/f-js-utils';

import 'src/global_jquery.js'
import 'src/vendor/jquery_geocomplete.js';
import 'easy-autocomplete';
import { API } from 'src/api';

application.register('autocomplete-address-2', class extends Controller {
  static targets = [
    'searchField',
    'latitudeField',
    'longitudeField',
    'mapEl',
    'overlay'
  ];
  static values = {
    slug: {
      type: String,
      default: ''
    }
  }

  initialize() {
    // TODO: migrate geocompletion to use fretadao's geocoding service
    this.$addressSearchInput = $(this.searchFieldTarget);
    this.$showSearch = $(".show-search-container");
    this.$hideSearch = $(".hide-search-container");
    this.$searchBarContainer = $(".search-bar-container");

    this.#setAutocomplete();
    this.#setupListeners();
  }

  #setAutocomplete() {
    if (this.$addressSearchInput.length) {
      this.geocomplete(this.$addressSearchInput, (res) => {
        [this.lat, this.lng] = res.coordinates.split(',');

        this.latitudeFieldTarget.value = parseFloat(this.lat);
        this.longitudeFieldTarget.value = parseFloat(this.lng);

        this.latitudeFieldTarget.dispatchEvent(new Event('change'));
        this.longitudeFieldTarget.dispatchEvent(new Event('change'));

        if (this.hasOverlayTarget) {
          addClass(this.overlayTarget, 'hidden');
        }
      });
    }
  }

  #setupListeners = () => {
    this.$showSearch.on('click', () => { this.#showSearchBar() });
    this.$hideSearch.on('click', () => { this.#hideSearchBar() });

    if (this.hasMapElTarget) {
      this.mapElTarget.addEventListener('geocomplete:markerMoved', ({ detail: ll }) => {
        if (isBlank(this.slugValue)) return;

        const csrfToken = find("meta[name='csrf-token']").content;

        API.b2bAdmin.routingLocate(csrfToken, this.slugValue, [ll.lat, ll.lng])
          .then(({ fullAddress }) => { this.searchFieldTarget.value = fullAddress })
          .catch((error) => {
            console.error(error);
            alert('Não foi possível encontrar o endereço do ponto de parada!');
          })
      });
    }
  };

  #showSearchBar = () => {
    this.$searchBarContainer.removeClass("hide-search");
    this.$searchBarContainer.addClass("show-search");
    this.$showSearch.css('display', 'none');
    this.$hideSearch.css('display', 'block');
  };

  #hideSearchBar = () => {
    this.$searchBarContainer.addClass("hide-search");
    this.$searchBarContainer.removeClass("show-search");

    this.$showSearch.css('display', 'block');
    this.$hideSearch.css('display', 'none');
  };

  geocomplete(reference, onLoadResult) {
    if (!reference) return;

    const geocoderApi = reference.parent().attr('data-geo');
    switch (geocoderApi) {
      case 'google':
        this.#googleGeocomplete(reference, onLoadResult);
        break;
      default:
        this.#hereGeocomplete(reference, onLoadResult);
        break;
    };
  }

  #googleGeocomplete = (reference, onLoadResult) => {
    // as implemented in app/assets/javascripts/fretadao/modules/searchBox.js
    let sessiontoken = this.#uuidv4();
    let options = {
      url: (phrase) => {
        return `/places/google/autocomplete?query=${phrase}&sessiontoken=${sessiontoken}`;
      },
      minCharNumber: 5,
      requestDelay: 200,
      theme: "square",
      getValue: "formatted_address",
      list: {
        onChooseEvent: () => {
          let itemData = reference.getSelectedItemData();

          $.get(`/places/google/autocomplete/${itemData.place_id}?sessiontoken=${sessiontoken}`, (data) => {
            if (data.coordinates != "") {
              sessiontoken = this.#uuidv4();
              onLoadResult($.extend(itemData, data));
              this.searchFieldTarget.dispatchEvent(new Event('onGeoInputSelectAddress'));
            } else {
              reference.val("");
            }
          });
        }
      },
    };

    reference.easyAutocomplete(options);
  }

  #hereGeocomplete = (reference, onLoadResult) => {
    // as implemented in app/assets/javascripts/fretadao/modules/searchBox.js
    let options = {
      url: (phrase) => {
        return `/places/here/autocomplete?query=${phrase}`;
      },
      minCharNumber: 5,
      requestDelay: 200,
      theme: "square",
      getValue: "formatted_address",
      list: {
        onChooseEvent: () => {
          let itemData = reference.getSelectedItemData();
          onLoadResult(itemData);
          this.searchFieldTarget.dispatchEvent(new Event('onGeoInputSelectAddress'));
        }
      },
    };

    reference.easyAutocomplete(options);
  }

  #uuidv4 = () => {
    // as implemented in app/assets/javascripts/fretadao/modules/searchBox.js
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
});
